import _merge from 'lodash/merge';
import _forEach from 'lodash/forEach';
import _size from 'lodash/size';
import _isUndefined from 'lodash/isUndefined';
import _toInteger from 'lodash/toInteger';

/**
 * @class
 * @memberof Product
 *
 * @description
 *
 * @param
 * _variants {Array Object}
 *
 * @return
 * self {instance} Tree
 */

var Tree = function(_variants) {
  var self = this;

  _merge(self.getTree(), self._build(_variants));

  _forEach(self.getTree(), function(leaf) {
    self._nodeAvailable(leaf);
  });

  return self;
};

/**
 * @private
 * @method
 *
 * @description
 * Строим дерево модификаций
 */
Tree.prototype._build = function(_variants) {
  var self = this;
  var tree = {};

  _forEach(_variants, function(variant) {
    var leaf = tree;

    if (variant.option_values.length) {
      // все хорошо, у нас много опций
      // Разбираем опции
      self._parseVariantOptions(variant, leaf);
    } else {
      // все плохо, у нас один вариант, нет опций
      self._addLeaf({
        id: 0,
        title: '_empty',
        position: 0,
        value_id: 0,
        option_id: 0,
      }, leaf, {
        id: variant.id,
        available: variant.available
      },
      variant);
    }
  });

  return tree;
};

/**
 * @private
 * @method
 *
 * @description
 * Разбираем опции варианта
 */
Tree.prototype._parseVariantOptions = function(variant, leaf) {
  var self = this;
  var _lastOptionIndex = _size(variant.option_values) - 1;

  _forEach(variant.option_values, function(option, index) {
    var _id;
    var _isAvailable;

    if (index == _lastOptionIndex) {
      _id = variant.id;
      _isAvailable = variant.available;
    }

    self._addLeaf(option, leaf, {
      id: _id,
      available: _isAvailable,
    }, variant);

    leaf = leaf[option.position].tree;
  });
};

/**
 * @private
 * @method
 *
 * @description
 * Добавляем узел дерева
 */
Tree.prototype._addLeaf = function(option, leaf, _set, variant) {
  var self = this;

  if (!leaf[option.position]) {
    leaf[option.position] = {
      id: option.id,
      tree: {},
      title: option.title,
      name: option.title.toLowerCase(),
      variant_id: _set.id,
      position: option.position,
      option_id: option.option_name_id,
      value_id: option.id,
    };
  }

  if (!_isUndefined(_set.available)) {
    leaf[_toInteger(option.position)].available = _set.available;
  }

  return leaf;
};

/**
 * @private
 * @method
 *
 * @description
 * Проставляем доступность
 */
Tree.prototype._nodeAvailable = function(leaf) {
  var self = this;

  if (_isUndefined(leaf.variant_id)) {
    var isAvailable = false;

    _forEach(leaf.tree, function(child) {
      if (self._nodeAvailable(child)) {
        isAvailable = true;
      }
    });

    leaf.available = isAvailable;
  }

  return leaf.available;
};

/**
 * @private
 * @method
 */
Tree.prototype.getTree = function() {
  var self = this;

  return self;
};

export default Tree;
